module.exports = __webpack_public_path__ + "img/logo.1227faf6.png";